import { render, staticRenderFns } from "./SubMenuHeader.vue?vue&type=template&id=2b2ad392&scoped=true"
import script from "./SubMenuHeader.vue?vue&type=script&lang=js"
export * from "./SubMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./SubMenuHeader.vue?vue&type=style&index=0&id=2b2ad392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ad392",
  null
  
)

export default component.exports